
import {NgIf} from '@angular/common';
import {CommonModule} from '@angular/common';
import {AfterViewInit, OnChanges, OnInit} from '@angular/core';
import {Component, SimpleChanges, TemplateRef, ViewChild} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {finalize, tap} from "rxjs";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput, MatInputModule} from "@angular/material/input";
import {OverlayContainer} from "@angular/cdk/overlay";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {ChangeDetectorRef} from '@angular/core';
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {MatNativeDateModule, MatOption} from "@angular/material/core";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {CookieService} from "ngx-cookie-service";
import { MatExpansionModule} from "@angular/material/expansion";
import { environment } from '../../../../environments/environment';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';
import { AnalyseService } from '../../../services/analyse-service/analyse.service';
import { HandleErrorsService } from '../../../services/handle-erros/handle.errors.service';
import { SampleStatusService } from '../../../services/sample-status-service/sample.status.service';
import { TerrrainService } from '../../../services/terrains-service/terrrain.service';
import { TypeAnalyseService } from '../../../services/type-analyse-service/type.analyse.service';
import { DialogService } from '../../_modal/dialog.service';
import { ApiService } from '../../_services/api.service';
import { Endpoints } from '../../endpoints';
import { MatChipsModule } from '@angular/material/chips';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { TypeAnalyseDTO } from '../../_models/typeAnalyseDTO';
import { MatriceService } from '../../../services/matrice-service/matrice.service';
import { MatSelectModule } from '@angular/material/select';
import { ParametreService } from '../../../services/parametre-service/parametre.service';
import { SampleService } from '../../../services/sample-service/sample.service';


@Component({
  selector: 'app-type-analyse',
    standalone: true,
    providers: [TerrrainService,AnalyseService, MatriceService,TypeAnalyseService, ApiService, Endpoints, DialogService, HandleErrorsService, SampleStatusService],
    imports: [MatExpansionModule,MatSelectModule,MatOption,
    MatNativeDateModule,
    CommonModule,
    MatCardModule, MatMenuModule, MatButtonModule,MatButtonToggleModule, MatTableModule, MatPaginatorModule, NgIf,
    MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput,MatChipsModule,MatSlideToggleModule,
    MatSuffix, MatSortModule, MatInputModule, MatDatepickerToggle,MatSelectModule,MatDatepicker, MatDatepickerInput, MatCheckbox],
    templateUrl: './type-analyse.component.html',
    styleUrl: './type-analyse.component.scss'
})

export class TypeAnalyseComponent  implements OnInit, OnChanges, AfterViewInit {

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('editModal') editModal: TemplateRef<any>;
    @ViewChild('viewModal') viewModal: TemplateRef<any>;
    form: FormGroup;
    searchVal: string = ''
    dataSource: MatTableDataSource<TypeAnalyseDTO> = new MatTableDataSource<TypeAnalyseDTO>();
    selectedMatrices: Set<TypeAnalyseDTO> = new Set<TypeAnalyseDTO>();
    isAllParameterSelected: boolean = false

    displayedColumns: string[] = [
      //'id',
      'codeAT',
      'name',
      'unite',
      'technique',
      'prix',
      'meq',
      'version',
      'dureeAna',
      'dureeEnvoi',
      'parameterIds',
      'departmentName',
      'methodesIds', 
      'description', 
      'action'
  ];
columnLabels: Record<string, string> = {
  codeAT: 'Code AT',
  name: 'Nom',
  unite: 'Unité',
  technique: 'Technique',
  prix: 'Prix',
  meq: 'MEQ',
  version: 'Version',
  dureeAna: 'Durée analyse',
  dureeEnvoi: 'Durée envoi',
  parameterIds: 'Paramètres',
  departmentName: 'Département',
  methodesIds: 'Méthodes',
  description: 'Description',
  action: 'Action',
};
    columns: string[] = [...this.displayedColumns];
    content: any;
    loadingTable: boolean = true;
    loadingOT: boolean = false
    loadingPdfGen: boolean = false
    loadingRapport: boolean = false
    loadingExcel: boolean = false
    panelOpenState = false;
    creatingParameter = false;
    toastr: any;
    typeAnalyse: any = { parameters: [] };  // Évite undefined au chargement




    ngOnInit() {
        this.fetchSampleList()
        this.getColsCookie()
        this.fetchMatrices()
        this.fetchParameters()
        this.loadDepartments();
        this.loadMethodes()
    }


    constructor(
        private cookieService: CookieService,
        private dialogService: DialogService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        public themeService: CustomizerSettingsService,
        private cdr: ChangeDetectorRef,
        private overlayContainer: OverlayContainer,
        private matriceService:MatriceService,
        private parameterService:ParametreService,
        private typeAnalyseService: TypeAnalyseService,
        private sampleService: SampleService,
        private handleErrors: HandleErrorsService) {
        this.initializeForm();
    }
    matrices: any[] = [];
    parameters: any[] = [];  
    methodes: any[] = [];  



    // Liste de tous les paramètres
allSelected = false;

// Toggle pour sélectionner ou désélectionner tous
toggleAllSelection() {
  if (this.allSelected) {
    // Déselectionner tout
    this.form.get('parameterIds')?.setValue([]);
    this.allSelected = false;
  } else {
    // Sélectionner tous les ids
    const allIds = this.parameters.map(p => p.id);
    this.form.get('parameterIds')?.setValue(allIds);
    this.allSelected = true;
  }
}
isAllSelected(): boolean {
  const selected = this.form.get('parameterIds')?.value || [];
  return this.parameters.length > 0 && selected.length === this.parameters.length;
}

    getMethodNames(methods: any[]): string {
        if (!methods || methods.length === 0) return '';
        return methods.map(m => m.name).join(', ');
        }

    loadDepartments() {
        this.sampleService.fetchDepartementList().subscribe({
        next: (res: any[]) => {
            this.departments = res;
            console.log('Liste des départements:', this.departments);
        },
        error: (err) => {
            console.error('Erreur lors du chargement des départements:', err);
        }
        });
  }
      loadMethodes() {
        this.typeAnalyseService.getMethodesList().subscribe({
        next: (res: any[]) => {
            this.methodes = res;
            console.log('Liste des methodes:', this.methodes);
        },
        error: (err) => {
            console.error('Erreur lors du chargement des départements:', err);
        }
        });
  }
  fetchMatrices() {
   this.matriceService.getAllMatrices().subscribe({
    next: (response) => {
      this.matrices = response.data; 
    },
    error: (error) => {
      console.error("Erreur lors de la récupération des matrices :", error);
    }
  });
}

getMatriceName(matriceId: number): string {
    const matrice = this.matrices.find(m => m.id === matriceId);
    return matrice ? matrice.nom : 'Non renseigné';
}

fetchParameters() {
    this.parameterService.getAllParameters().subscribe({
     next: (response) => {
        console.log("dataa:",response.data)
       this.parameters = response.data; 
     },
     error: (error) => {
       console.error("Erreur lors de la récupération des parameters :", error);
     }
   });

 }
 
    getParameterNames(parameters: any[]): string {

        return parameters && parameters.length > 0 
            ? parameters.map(param => param.name).join(', ') 
            : 'Aucun paramètre';
    }
selectedTypeAnalyse: any;

    getParameterName(parameters: any[]): string {
        if (!parameters || parameters.length === 0) {
            return 'Aucun paramètre';
        }

    // Si tous les éléments sont des IDs
    const isAllIds = parameters.every(param => typeof param === 'number');

    if (isAllIds) {
        if (!this.parameters || this.parameters.length === 0) {
            return 'Chargement des paramètres...';
        }

        const selectedParams = this.parameters.filter(param => parameters.includes(param.id));
        console.log('Paramètres sélectionnés (IDs) :', selectedParams);

        return selectedParams.length > 0 
            ? selectedParams.map(param =>
                param?.pesticide?.pesticideResidueName || param?.codeParameter || 'Paramètre inconnu'
              ).join(', ')
            : 'Aucun paramètre';
    }

    // Cas d'objets ou mixte
    return parameters.map(param => {
        if (typeof param === 'object') {
            return (
                param?.pesticide?.pesticideResidueName ||
                param?.codeParameter ||
                'Paramètre inconnu'
            );
        } else if (typeof param === 'number') {
            const match = this.parameters?.find(p => p.id === param);
            return (
                match?.pesticide?.pesticideResidueName ||
                match?.codeParameter ||
                'Paramètre inconnu'
            );
        } else {
            return 'Paramètre inconnu';
        }
    }).join(', ');
}


    ngOnChanges(changes: SimpleChanges) {
        if (changes['dataSource']) {
            this.initializeForm();
        }
    }
  departments: any[] = [];

    initializeForm() {
      this.form = this.fb.group({
          id: [''],
          codeAT: ['', Validators.required],
          unite:[''],
          technique:[''],
          name: ['', Validators.required],
          description: [''],
          prix: [''],
          meq: [''],
          version: [''],
          dureeAna: [''],
          dureeEnvoi: [''],
          //matriceId: [''],
          parameterIds: [[]],
          methodesIds: [[]],
          departmentId: ['', Validators.required], 
          creationDate: [new Date(), Validators.required],
          updateDate: [''],
      });
  }

    
    ngAfterViewInit() {
        this.initializePaginatorAndSort()
    }

    initializePaginatorAndSort() {
        this.overlayContainer.getContainerElement().style.zIndex = '2000';
        this.dataSource.filter = this.searchVal
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'desc';

    }

    editTypeAnalyse(typeAnalyse: any) {
        console.log("Type Analyse sélectionnée pour modification :", typeAnalyse);
            const { creationDate, updateDate, ...filteredTypeAnalyse } = typeAnalyse;
    
        this.form.patchValue({
            id: filteredTypeAnalyse.id,
            codeAT: filteredTypeAnalyse.codeAT,
            unite: filteredTypeAnalyse.unite,
            technique: filteredTypeAnalyse.technique,
            name: filteredTypeAnalyse.name,
            description: filteredTypeAnalyse.description,
            prix: filteredTypeAnalyse.prix,
            meq: filteredTypeAnalyse.meq,
            version: filteredTypeAnalyse.version,
            dureeAna: filteredTypeAnalyse.dureeAna,
            dureeEnvoi: filteredTypeAnalyse.dureeEnvoi,
            //matriceId: filteredTypeAnalyse.matriceId || null,
            departmentId:filteredTypeAnalyse.departmentId,
            departmentName:filteredTypeAnalyse.departmentName,
            parameterIds: (filteredTypeAnalyse.parameters || []).map((p: { id: any; }) => p.id),
            methodesIds: (filteredTypeAnalyse.methodes || []).map((p: { id: any; }) => p.id)

 
        });
    
        console.log("Formulaire après patchValue :", this.form.value);
        this.modalService.open(this.editModal, { size: 'lg' });
    }
    
          
    saveUpdatedTypeAnalyse() {
        console.log("Formulaire de mise à jour soumis :", this.form.value);

        if (this.form.invalid) {
            console.warn("Champs invalides :", this.form.controls);
        }

        const updatedTypeAnalyse = { ...this.form.value };

        // Supprimer dates inutiles
        delete updatedTypeAnalyse.creationDate;
        delete updatedTypeAnalyse.updateDate;

        // ✅ Convertir departmentId Array → Long
        if (Array.isArray(updatedTypeAnalyse.departmentId)) {
            updatedTypeAnalyse.departmentId = updatedTypeAnalyse.departmentId[0];
        }

        console.log("Type Analyse mise à jour à envoyer :", updatedTypeAnalyse);

        if (!updatedTypeAnalyse.id) {
            console.error("L'ID du type d'analyse est manquant.");
            return;
        }

        this.typeAnalyseService.updateTypeAnalyse(
            updatedTypeAnalyse.id, 
            updatedTypeAnalyse
        ).subscribe({
            next: (response) => {
                console.log("Réponse du backend :", response);

                if (response && response.id) {
                    console.log("✅ Mise à jour réussie !");
                    this.modalService.dismissAll();
                    this.cdr.detectChanges();
                    this.fetchSampleList(); 
                } else {
                    console.error("⚠️ Échec de la mise à jour : Réponse inattendue.", response);
                }
            },
            error: (error) => {
                console.error("❌ Erreur lors de la mise à jour du type d'analyse :", error);
            }
        });
    }


    openEditModal(matrice: any) {
            console.log("Parameter sélectionnée :", matrice);
            this.form.patchValue(matrice);
            this.cdr.detectChanges(); 
            this.modalService.open(this.editModal, { ariaLabelledBy: 'modal-basic-title', size: 'xl' });
        }
        
  openViewModel(typeAnalyse: any) {
    console.log("typeAnalyse sélectionnée :", typeAnalyse);

    // ✅ Stocker l'objet COMPLET pour l'affichage (méthodes, paramètres, etc.)
    this.selectedTypeAnalyse = typeAnalyse;

    if (this.form) {
        this.form.patchValue({
            id: typeAnalyse.id || null,
            codeAT: typeAnalyse.codeAT || '',
            technique:typeAnalyse.technique || '',
            unite:typeAnalyse.unite || '',
            name: typeAnalyse.name || '',
            description: typeAnalyse.description || '',
            prix: typeAnalyse.prix || '',
            meq: typeAnalyse.meq || '',
            version: typeAnalyse.version || '',
            dureeAna: typeAnalyse.dureeAna || '',
            departementId: typeAnalyse.departmentId,
            departementName: typeAnalyse.departmentName,
            dureeEnvoi: typeAnalyse.dureeEnvoi || '',
           // matriceId: typeAnalyse.matriceId || null,

            // ✅ IDs uniquement pour le formulaire
            parameterIds: Array.isArray(typeAnalyse.parameters)
                ? typeAnalyse.parameters.map((p: { id: number }) => p.id)
                : [],

            methodesIds: Array.isArray(typeAnalyse.methodes)
                ? typeAnalyse.methodes.map((m: { id: number }) => m.id)
                : []
        });
    }

    this.cdr.detectChanges();

    this.modalService.open(this.viewModal, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'xl'
    });
}

    updateTableRow(updatedData: any) {
        const index = this.dataSource.data.findIndex(item => item.id === updatedData.id);
        if (index !== -1) {
            this.dataSource.data[index] = updatedData;
        }
    }

    confirmDelete(element: any) {
        this.dialogService.open('Vous etes sur de supprimer cet type d analyse?', environment.warning_message_type, 'danger', environment.warning_icon, true)
            .then((result: any) => {
                if (result) {
                    this.deleteTypeAnalyse(element.id);
                }
            });
    }

    deleteTypeAnalyse(id: number) {
        console.log("Suppression de la parameter avec l'id:", id); 

        this.typeAnalyseService.deleteTypeAnalyse(id).pipe(
            tap((response: any) => {
                if (response.status) {
                    this.removeTableRow(id);
                    this.dialogService.openSuceessAlert('Parameter supprimé avec succès' );
                }
            }),
            finalize(() => {
                this.dataSource.paginator = this.paginator;
            })
        ).subscribe();
    }

    removeTableRow(id: number) {
        this.dataSource.data = this.dataSource.data.filter(sample => sample.id !== id);
        this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
    }

    applyFilter(event: Event) {
        this.searchVal = (event.target as HTMLInputElement).value.trim().toLowerCase();
        this.dataSource.filter = this.searchVal
    }

    handleSelection(sam: TypeAnalyseDTO) {
        this.selectedMatrices.has(sam) ? this.selectedMatrices.delete(sam) : this.selectedMatrices.add(sam)
    }
    handleSelectAll() {
        this.isAllParameterSelected = !this.isAllParameterSelected;
        
        if (this.isAllParameterSelected) {
            this.selectedMatrices = new Set<TypeAnalyseDTO>(this.dataSource.filteredData);
        } else {
            this.selectedMatrices = new Set<TypeAnalyseDTO>();
        }
    }
    
    openModal(content: any) {
        this.form.reset()
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'xl'}).result.then(
            (result) => {
                if (result === 'save') {
                }
            }
        );
    }
    
    saveTypeAnalyse() { 
        const formatDate = (date: any) => {
            if (date instanceof Date) {
                return date.toISOString().split('T')[0]; 
            }
            return date; 
        };
    
        let updateDate = this.form.get('updateDate')?.value;
        updateDate = updateDate ? formatDate(updateDate) : null;
    
        //const matriceId = this.form.get('matriceId')?.value;
        const methodeIds = this.form.get('methodeIds')?.value;
        const parameterIds = this.form.get('parameterIds')?.value; // Récupération de l'ID du Parameter
        const departmentIdArray = this.form.get('departmentId')?.value; // Array
        const departmentId = Array.isArray(departmentIdArray) ? departmentIdArray[0] : departmentIdArray;

        this.form.patchValue({ updateDate });
    
        const newTypeAnalyse = { 
            ...this.form.value, 
           // matriceId,
            parameterIds,
            departmentId        };
    
        console.log("Nouveau TypeAnalyse à envoyer:", newTypeAnalyse);
    
        this.creatingParameter = true;
    
        this.typeAnalyseService.createTypeAnalyse(newTypeAnalyse).subscribe({
            next: (response) => {
                console.log("Réponse du backend:", response);
                this.creatingParameter = false;
    
                if (response) {
                    this.modalService.dismissAll(); 
                    this.cdr.detectChanges(); 
                    this.fetchSampleList(); 
                } else {
                    console.error("Échec de la création du TypeAnalyse");
                }
            },
            error: (error) => {
                console.error("Erreur lors de la création du TypeAnalyse:", error);
                this.creatingParameter = false;
            }
        });
    }
    
fetchSampleList() {
    this.typeAnalyseService.getAllTypeAnalyses().subscribe({
        next: (response: any[]) => {
            console.log("Réponse API avant transformation:", response);

            if (!response || !Array.isArray(response)) {
                console.error("Réponse API invalide ou vide !");
                this.loadingTable = false;
                return;
            }

            // Pas besoin de transformer les objets s’ils viennent déjà formatés
            this.dataSource.data = response;

            console.log("Données après transformation:", this.dataSource.data);
            this.loadingTable = false;
        },
        error: err => {
            console.error("Erreur API:", err);
            this.handleErrors.catchError(err);
            this.loadingTable = false;
        }
    });
}

    
    

    handleIsAllColsSelected(event: MatCheckboxChange) {
        if (event.checked) {
            this.displayedColumns = [...this.columns]
        } else {
            this.displayedColumns = []
        }
        this.setColsCookie()
    }

    getdisplayedCol = (): string[] => {
        return ['select', ...this.displayedColumns, 'action']
    };

    onSelectionChange(column: string): void {
        if (this.displayedColumns.includes(column)) {
            this.displayedColumns = this.displayedColumns.filter(c => c !== column);
        } else {
            this.displayedColumns.push(column)
        }
        this.setColsCookie()
    }

    user_name = sessionStorage.getItem('user_name');

    private setColsCookie() {
        this.cookieService.set(`tyepAnalCol_${this.user_name}`, JSON.stringify(this.displayedColumns), {
            expires: 7,
            path: '/',
            secure: true
        });
    }
private getColsCookie() {
    const sampleCols = this.cookieService.get(`tyepAnalCol_${this.user_name}`);

    if (sampleCols) {
        const parsedCols = JSON.parse(sampleCols);

        // 🔥 فلترة أي أعمدة غير موجودة في columns الأصلية
        this.displayedColumns = parsedCols.filter((col: string) =>
            this.columns.includes(col)
        );
    }
}

    openImportModal(importModal: any) {
        this.modalService.open(importModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'})
    }
}
